import Icon from "../../../UI/Icon/Icon";
import classes from "./OrderType.module.scss";

const OrderTypeBox = ({
  index,
  engText,
  arabicText,
  icon,
  onClicked,
  isSelected,
}) => {
  return (
    <div
      tabIndex={index}
      className={classes.OrderTypeBox}
      onClick={() => onClicked(engText)}
      onKeyDown={(e) => {
        if (e.code === "Enter") {
          onClicked(engText);
        }
      }}
    >
      <Icon name={icon} height={4.8} width={4.8} />
      <h2 className={classes.OrderEngName}>{engText}</h2>
      <h2 className={classes.OrderArabicName}>{arabicText}</h2>
      {isSelected && (
        <div className={classes.Selected}>
          <Icon name="tick" width={5.6} height={5.6} />
        </div>
      )}
    </div>
  );
};

export default OrderTypeBox;
